import React from 'react'
import SkillFourTeacher from '../feature/SkillBox/SkillFourTeacher'

const SkillFourTeacherPage = () => {
  return (
   <SkillFourTeacher/>
  )
}

export default SkillFourTeacherPage
